import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

const HOST = 'https://www.christianfamilyrecovery.com';
const ORG = {
  '@type': 'Organization', '@id': `${HOST}/#organization`, name: 'Christian Family Recovery', url: HOST,
  logo: { '@type': 'ImageObject', url: `${HOST}/favicon-512.png` }, founder: { '@type': 'Person', name: 'Pastor Simon' },
  description: 'Faith-based addiction recovery courses for the person in recovery, their family, and the churches and rehab centres standing with them.',
  sameAs: [], contactPoint: { '@type': 'ContactPoint', contactType: 'customer support', url: `${HOST}/contact` },
};
// Legacy detail-page paths that describe a priced course listing.
const PATH_TO_SLUG = {
  '/courses/walking-it-out-addict': 'walking-it-out', '/courses/walking-it-out-family': 'walking-it-out',
  '/courses/still-walking-it-out-addict': 'still-walking-it-out', '/courses/still-walking-it-out-family': 'still-walking-it-out',
  '/courses/walking-in-freedom': 'walking-in-freedom', '/walking-it-out': 'walking-it-out',
};

let cache = null;
const loadPricing = () => cache || (cache = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/course-pricing`).then((r) => r.data.courses || []).catch(() => { cache = null; return []; }));

export const courseSchema = (c, path) => ({
  '@context': 'https://schema.org', '@type': 'Course', '@id': `${HOST}${path}#course`, name: c.title, description: c.description, url: `${HOST}${path}`,
  image: c.image_url, provider: ORG, inLanguage: c.has_spanish ? ['en', 'es'] : 'en', timeRequired: `P${c.weeks || 8}W`, educationalCredentialAwarded: 'Certificate of completion',
  hasCourseInstance: { '@type': 'CourseInstance', courseMode: 'online', courseWorkload: `P${c.weeks || 8}W`, courseSchedule: { '@type': 'Schedule', repeatFrequency: 'P1W', repeatCount: c.weeks || 8 } },
  offers: { '@type': 'Offer', price: String(c.price), priceCurrency: 'USD', availability: 'https://schema.org/InStock', category: 'One-time purchase', url: `${HOST}${path}` },
});

export default function SchemaByRoute() {
  const { pathname } = useLocation();
  const [courses, setCourses] = useState([]);
  const path = pathname.replace(/\/+$/, '') || '/';
  const slug = PATH_TO_SLUG[path] || (path.startsWith('/course/') ? path.split('/')[2] : null);

  const wantsPricing = Boolean(slug) || path === '/courses';
  useEffect(() => { if (wantsPricing) loadPricing().then(setCourses); }, [wantsPricing]);

  if (path === '/courses' && courses.length) {
    return <Helmet><script type="application/ld+json">{JSON.stringify({ '@context': 'https://schema.org', '@type': 'ItemList', name: 'Christian Family Recovery courses', itemListElement: courses.map((c, i) => ({ '@type': 'ListItem', position: i + 1, item: courseSchema(c, `/course/${c.course_id}`) })) })}</script></Helmet>;
  }
  const c = slug && courses.find((x) => x.course_id === slug);
  if (!c) return null;
  return <Helmet><script type="application/ld+json" data-testid="course-schema">{JSON.stringify(courseSchema(c, path))}</script></Helmet>;
}
